import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n-lite';
import * as groupsApi from '../../../services/api/groupApi';

/**
 * Mobile group selection of the Assign sheet (Vista Mobile 3a, 3b, 3d): every group visible in a
 * 4-column grid, "Everyone" first. The group colour only shows on the selected one.
 * Below, multiple selection: an entry row, or a summary with "Edit" when students are already chosen.
 */
export const AssignGroupGrid = ({
  label,
  groups,
  currentSelection,
  selectGroup,
  openChooseMultiple,
  everyoneIcon,
  everyoneIconBg
}) => {
  const selectedUsers = currentSelection && currentSelection.isGroup === false ? currentSelection.users || [] : [];

  const renderGroup = group => {
    const isEveryone = group.id === 0;
    const isSelected = Boolean(currentSelection && currentSelection.isGroup && currentSelection.id === group.id);
    const colourClass = isEveryone ? 'group-item-everyone' : `group-item-${group.colour}`;

    return (
      <button
        key={group.id}
        type="button"
        className={`assign-group ${isSelected ? `selected ${colourClass}` : ''}`}
        aria-pressed={isSelected}
        onClick={() => selectGroup(group.id)}
      >
        <span className="assign-group-circle">
          {isEveryone ? (
            <img src={isSelected ? everyoneIcon : everyoneIconBg} alt="" />
          ) : (
            <span>{groupsApi.getGroupFirstChar(group)}</span>
          )}
          {isSelected && <i className="custom-icons-check-icon assign-group-check" aria-hidden="true" />}
        </span>
        <span className="assign-group-name">{groupsApi.getGroupName(group)}</span>
      </button>
    );
  };

  return (
    <div className="assign-sheet-groups">
      <span className="assign-sheet-label">{label}</span>
      {groups && groups.length > 0 && (
        <>
          <div className="assign-group-grid">{groups.map(renderGroup)}</div>
          <div className="assign-sheet-or">{I18n.t('common.or')}</div>
        </>
      )}
      {selectedUsers.length > 0 ? (
        <button type="button" className="assign-multiple assign-multiple--summary" onClick={openChooseMultiple}>
          <span className="assign-multiple-icon">
            <i className="custom-icons-group-users-avatar" aria-hidden="true" />
          </span>
          <span className="assign-multiple-text">
            <span className="assign-multiple-title">
              {I18n.t('mobileSheets.multipleSelectionStudents', { count: selectedUsers.length })}
            </span>
          </span>
          <span className="assign-multiple-edit">{I18n.t('common.option.edit')}</span>
        </button>
      ) : (
        <button type="button" className="assign-multiple" onClick={openChooseMultiple}>
          <span className="assign-multiple-icon">
            <i className="custom-icons-group-users-avatar" aria-hidden="true" />
          </span>
          <span className="assign-multiple-text">
            <span className="assign-multiple-title">{I18n.t('rightPanel.multiple.assignTitle')}</span>
            <span className="assign-multiple-subtitle">{I18n.t('mobileSheets.multipleSelectionHelp')}</span>
          </span>
          <i className="custom-icons-right-chevron assign-multiple-chevron" aria-hidden="true" />
        </button>
      )}
    </div>
  );
};

AssignGroupGrid.propTypes = {
  label: PropTypes.string,
  groups: PropTypes.array,
  currentSelection: PropTypes.object,
  selectGroup: PropTypes.func.isRequired,
  openChooseMultiple: PropTypes.func.isRequired,
  everyoneIcon: PropTypes.string,
  everyoneIconBg: PropTypes.string
};

const mapStateToProps = state => ({
  everyoneIcon: state.theme.images.icons.groupColor,
  everyoneIconBg: state.theme.images.icons.groupBg
});

export default connect(mapStateToProps)(AssignGroupGrid);
